import React, { useState, useEffect } from "react";
import { storage, ref, uploadBytes, getDownloadURL, listAll } from "./FireBase";
import { useNavigate, useLocation } from "react-router-dom";
import "./FirebaseFile.css"; 


const FirebaseFile = () => {
  const [file, setFile] = useState(null);
  const [files, setFiles] = useState([]);
  const navigate = useNavigate();

  const uploadFile = async () => {
    if (!file) return alert("Please select a file first!");
  
    const storageRef = ref(storage, `uploads/${file.name}`);
    try {
      
      await uploadBytes(storageRef, file);
      alert("File uploaded successfully!");
      
     
      setTimeout(fetchFiles, 1000);
    } catch (error) {
      console.error("Upload error:", error);
    }
  };
  

  const fetchFiles = async () => {
    try {
      const listRef = ref(storage, "uploads/"); 
      const result = await listAll(listRef);
  
      // Fetch filenames, URLs, and categorize by file type
      const filesData = await Promise.all(
        result.items.map(async (item) => {
          const url = await getDownloadURL(item);
          const filename = item.name;
  
          // Extract file extension
          const extension = filename.split('.').pop().toLowerCase();
  
          // Define categories based on extensions
          let fileType = "other"; // Default category
          const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
          const videoExtensions = ["mp4", "mkv", "avi", "mov", "wmv", "flv"];
  
          if (imageExtensions.includes(extension)) {
            fileType = "image";
          } else if (videoExtensions.includes(extension)) {
            fileType = "video";
          }
  
          return { filename, url, fileType };
        })
      );
  
      console.log(filesData);
      setFiles(filesData);  // Update state with categorized files
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };
  

  useEffect(() => {
    fetchFiles();
  }, []);

  return (
    <div className="outercontainer">
      <h2>Firebase File Upload & Fetch</h2>

      <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      <button onClick={uploadFile}>Upload</button>

      <button onClick={() => navigate("/")}>Home</button>
      <h3>Uploaded Files:</h3>
    
      <div className="files-container">
  {files.map((file, index) => (
    <div className="container" key={index}>
      <div className="innercontainer">
        {file.fileType === "image" ? (
          <img src={file.url} alt={file.filename} />
        ) : file.fileType === "video" ? (
          <video controls>
            <source src={file.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <a href={file.url} target="_blank" rel="noopener noreferrer">
            {file.filename}
          </a>
        )}
      </div>
      <p>{file.filename}</p>
    </div>
  ))}
</div>



  



    </div>
  );
};

export default FirebaseFile;
